import { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartSoftButton,
  SmartTable,
  SmartTableNewInterface,
} from "sds_react_toolkit";
import { COMPANY_URLS } from "../../api/ManageUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose, showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import CompanyForm from "./CompanyForm";

const CompanyTable = () => {
  const [tabData, setTabData] = useState<any[]>([]);
  const [filterType, setFilterType] = useState<string>("all"); // all, company, index

  const { openModal, setTitle } = useSiteContext();

  const loadTableData = () => {
    const URL =
      filterType === "all"
        ? COMPANY_URLS.GET_ALL
        : `${COMPANY_URLS.GET_ALL}?entity_type=${filterType}`;

    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data || []);
    });
    return () => subscription.unsubscribe();
  };

  useEffect(() => {
    setTitle("Companies & Indices Management");
    loadTableData();
  }, [filterType]);

  const deleteData = (id: number) => {
    const subscription = post(`${COMPANY_URLS.DELETE}${id}`, {}).subscribe(() => {
      showAlertAutoClose("Deleted Successfully", "success");
      loadTableData();
    });
    return () => subscription.unsubscribe();
  };

  const openDeleteModal = (row: any) => {
    const alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-exclamation-triangle"></i> Confirm Deletion
        </span>
      ),
      alertFunction: (option:any) => {
        if (option === "yes") {
          deleteData(row.id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Do you want to delete <strong>{row.name}</strong>? <br />
          <strong>This action cannot be undone.</strong>
        </p>
      ),
      className: "custom-alert",
    };
    SmartAlert.show(alertProps);
  };

  const openCompanyForm = (data: any) => {
    const options = {
      title: data ? `Edit ${data.entity_type === 'index' ? 'Index' : 'Company'}` : "Add New Company/Index",
      content: <CompanyForm loadTableData={loadTableData} data={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };

  const viewEditForm = (id: number) => {
    const subscription = get(`${COMPANY_URLS.GET_ONE}${id}`).subscribe(
      (response: any) => {
        openCompanyForm(response.data || null);
      }
    );
    return () => subscription.unsubscribe();
  };
const StatusUpdate = (
  id: number,
  status: any,
  loadTableData: () => void
) => {
  const subscription = post(`${COMPANY_URLS.STATUS_UPDATE}${id}`, {
    is_active: status,
  }).subscribe(() => {
    loadTableData();
  });

  return () => subscription.unsubscribe();
};


const updateStatus = (
  item: any,
  loadTableData: () => void
) => {
  const newStatus: any =
    item.is_active === "active" ? "inactive" : "active";

  const msg =
    newStatus === "active"
      ? "Do you want to Activate?"
      : "Do you want to Deactivate?";

  showYesOrNoAlert(
    msg,
    (selection: any) =>
      updateStatusFinal(selection, item, newStatus, loadTableData),
    "info"
  );
};



const updateStatusFinal = (
  selection: any,
  item: any,
  newStatus: any,
  loadTableData: () => void
) => {
  if (selection === "yes") {
    // Optimistic UI update
    item.is_active = newStatus;

    // API call
    StatusUpdate(item.id, newStatus, loadTableData);
  }
};




const SwitchForm = (
  item: any,
) => {
  return (
    item.id && (
      <div className="field">
        <input
          id={`switch_${item.id}`}
          type="checkbox"
          className="switch is-small"
          checked={item.is_active === "active"}
          onChange={() => updateStatus(item, loadTableData)}
        />
        <label htmlFor={`switch_${item.id}`}></label>
      </div>
    )
  );
};


  const buttons = [
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-pencil-square",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => viewEditForm(data.id),
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => openDeleteModal(data),
    },
  ];

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    {
      title: "Type",
      index: "entity_type",
 
      width: "8",
      isFilterable: true,
      isSortable: true,
      valueFunction: (row: any) => (
        <span
          className={`tag ${
            row.entity_type === "index" ? "is-info" : "is-success"
          }`}
        >
          {row.entity_type === "index" ? "Index" : "Company"}
        </span>
      ),
    },
    {
      title: "Name",
      index: "name",
      isSortable: true,
      isFilterable: true,
      width: "20",
    },
    {
      title: "Symbol",
      index: "symbol",
      isSortable: true,
      isFilterable: true,
      width: "10",
    },
    {
      title: "Exchange",
      index: "exchange",
      width: "8",
      isFilterable: true,
    },
    {
      title: "ISIN",
      index: "isin",
      width: "12",
    },
    {
      title: "Sector",
      index: "sector_id",
      width: "12",
      isFilterable: true,
   
      valueFunction: (row: any) => (
        <span>{row.sector_id?.label || "-"}</span>
      ),
    },
    {
      title: "Market Cap",
      index: "market_cap_category",
      width: "10",
  
      valueFunction: (row: any) => {
        if (row.entity_type === "index") {
          return row.current_value ? `₹${row.current_value.toFixed(2)}` : "-";
        }
        return row.market_cap_category || "-";
      },
    },
    // {
    //   title: "Status",
    //   index: "is_active",
    //   width: "8",
     
    //   valueFunction: (row: any) => (
    //     <span
    //       className={`tag ${
    //         row.is_active === "active"
    //           ? "is-success"
    //           : row.is_active === "delisted"
    //           ? "is-danger"
    //           : "is-warning"
    //       }`}
    //     >
    //       {row.is_active}
    //     </span>
    //   ),
    // },
        {
      title: "Status",
      index: "is_active",
      valueFunction: SwitchForm,
      width: "5",
    },
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons,
      width: "10",
    },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold">Companies & Indices</p>,
    },

    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-1",
      align: "RIGHT",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
      ],
    },
    {
      type: "CUSTOM",
      widthClass: "is-1",
      align: "RIGHT",
      custom: (
        <SmartSoftButton
          label="Add"
          onClick={() => openCompanyForm(null)}
          leftIcon="fa-plus"
          classList={["smart-action-button"]}
        />
      ),
    },
  ];

  return (
    <div className="sd-efl-input">
      <SmartTable
        columns={columns}
        data={tabData}
        tableTop={tableTop}
        tableProps={{
          className: "is-hoverable is-striped dsc-table-container",
          isResponsive: true,
          searchPlaceHolder: "Search companies & indices",
        }}
        paginationProps={{
          pageSize: 10,
        }}
      />
    </div>
  );
};

export default CompanyTable;
